import React from 'react'

import { CtaOptionsContainer } from './ctaOptionsStyled'
import { CtaOptionCreateAccount } from './CtaOptionCreateAccount/ctaOptionCreateAccount'
import { ButtonProps } from '../../types/interfaces/buttonInterface'


export interface CtaOptionsProps {
  onClick?: ButtonProps['onClick']  // same signature as your Button
}

export const CtaOptions: React.FC<CtaOptionsProps> = ({ onClick }) => {

    const options = (
        <>
            <CtaOptionCreateAccount onClick={onClick} />
        </>
    )

    return <CtaOptionsContainer>{options}</CtaOptionsContainer>
}
